export const enum Weekday {
    Monday = 1,      // понедельник
    Tuesday = 2,     // вторник
    Wednesday = 3,   // среда
    Thursday = 4,    // четверг
    Friday = 5,      // пятница
    Saturday = 6,    // суббота
    Sunday = 7,      // воскресенье
    // vuetify uses 0-based weekdays count
    Sunday_Zero = 0, // воскресенье 
}

export interface CalendarDate {
    year: number,
    month: number,
    day: number,
}

export interface Time {
    hour: number,
    minute: number,
}

export type DateTime = CalendarDate & Time;

export type Timestamp = number;
export type ISOCalendarDate = string; // YYYY-MM-DD
export type ISOMonth = string; // YYYY-MM
export type ISOTime = string; // HH:mm
export type ISODateTime = string; // YYYY-MM-DD HH:mm

type Range<T> = {
    start: T,
    end: T,
}

export type ISODateRange = Range<ISOCalendarDate>;
export type ISODateTimeRange = Range<ISODateTime>;
